import { Component, inject, signal, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MaintenanceStatusService } from '../../lib/services';
import { delay } from 'rxjs';
import { AuthenticationService } from '@my-aon/auth';

@Component({
    selector: 'app-out-of-service',
    templateUrl: './out-of-service.component.html',
    styleUrls: ['./out-of-service.component.scss'],
    standalone: true,
    host: {
        '[style.display]': 'display()',
        '[style.visibility]': 'visibility()',
    },
})
export class OutOfServiceComponent {

    readonly service: MaintenanceStatusService = inject(MaintenanceStatusService);
    readonly auth: AuthenticationService = inject(AuthenticationService);

    $underMaintenance = signal<boolean>(false);
    display = computed<string>(() => this.$underMaintenance() ? 'block' : 'none');

    visibility = computed<string>(() => this.$underMaintenance() ? 'visible' : 'hidden');

    loadIndicatorVisible: boolean = true;

    imageSrc: string;
    srcset: string;
    sizes: string;

    constructor() {
        let sizes = [640, 800, 1024, 1280, 1680];

        (this.imageSrc = `/images/under_maintenance_640.jpg`),
            (this.srcset = sizes
                .map((size) => `/images/under_maintenance_${size}.jpg ${size}w`)
                .join(', ')),
            (this.sizes = sizes
                .map((size, index) => {
                    if (index === 0) return;

                    if (index === sizes.length - 1) return `${size}px`;

                    let a = sizes[index - 1],
                        b = size;
                    return `(max-width: ${b}px) ${a}px`;
                })
                .filter((x) => !!x)
                .join(', '));

        this.service.underMaintenance$
            .pipe(delay(500))
            .pipe(takeUntilDestroyed())
            .subscribe((result) => this.$underMaintenance.set((this.auth.hasAdminModuleAccess()) ? false : result));
    }
}
